import { createSelector, createSlice } from '@reduxjs/toolkit';

import { listSmurTeams, selectAllSmurTeams } from './smurTeamSlice';

const REDUCER_NAME = 'geolocation';

const initialState = {
  pickedObjectId: null,
  currentCenter: null,
  currentZoom: 12,
  googleMapsAPIKey: null,
};

const geolocationSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    pickItem(state, { payload }) {
      if (state.currentZoom !== 14) {
        state.currentZoom = 14;
      }
      state.pickedObjectId = payload.objectId;
    },
    unpickItem(state) {
      state.currentZoom = 12;
      state.pickedObjectId = null; // does multiple select make sense?
    },
    setCurrentCenter(state, { payload }) {
      state.currentCenter = payload.position;
    },
    setLastCenter(state, { payload }) {
      state.lastCenter = payload.position;
    },
    setZoom(state, { payload }) {
      // we clamp the zoom between those values to avoid zooming in and out too far when clicking on icon
      if (payload.zoom <= 14 && payload.zoom >= 10) {
        state.currentZoom = payload.zoom;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listSmurTeams.fulfilled, (state, { payload }) => {
      state.googleMapsAPIKey = payload.googleMapsAPIKey;
    });
  },
});
/**
 * @typedef {Object} Markers
 * @property {Object[]} facilities
 * @property {Object[]} smurTeams
 * @property {Object[]} interventions
 */
/**
 * Select all markers to be placed on the map
 * @returns {Markers}
 */
export const selectAllMarkers = createSelector(
  (state) => selectAllSmurTeams(state),
  (smurTeams) => {
    return { smurTeams };
  });
export const selectPickedItem = createSelector(
  [(state) => state.geolocation, selectAllMarkers],
  (geolocationState, markers) => markers.find((item) => item.id === geolocationState.geolocation.pickedObjectId));
export const {
  pickItem,
  unpickItem,
  setCurrentCenter,
  setLastCenter,
  setZoom,
} = geolocationSlice.actions;

export default geolocationSlice.reducer;
